require("prismjs/themes/prism-solarizedlight.css");
require("prismjs/plugins/line-numbers/prism-line-numbers.css");

// In development, ensure no stale service workers interfere with dev runtime
export const onClientEntry = () => {
  if (
    process.env.NODE_ENV === "development" &&
    typeof navigator !== "undefined" &&
    "serviceWorker" in navigator
  ) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister().catch(() => {}));
    });
  }
};
